import { render, staticRenderFns } from "./ClassMember.vue?vue&type=template&id=08813806&"
import script from "./ClassMember.vue?vue&type=script&lang=js&"
export * from "./ClassMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports